import React from "react";
import "./CertificateGroupingGWPGeneral.scss";
import CertificateGroupingListGWPGeneralReview from "../../features/CertificateGroupingListGWPGeneralReview/CertificateGroupingListGWPGeneralReview";


const CertificateGroupingGWPGeneralForReview = () => {
  return (
    <div className="analytics-page">
      <CertificateGroupingListGWPGeneralReview />
    </div>
  );
};

export default CertificateGroupingGWPGeneralForReview;